import { useState } from "react";
import { QRCodeSVG } from "qrcode.react";
import { useTranslation } from "react-i18next";
import { Printer, RefreshCw, Trash2 } from "lucide-react";
import { NeuButton } from "../../../components/neu/Neu";
import { QrPrintModal } from "./QrPrintModal";

// بطاقة منطقة واحدة: رمز QR + فتح نافذة عرض/طباعة كبيرة + تدوير + تشغيل/إيقاف + حذف.
export const QrZoneCard = ({ zone, branchName, onRotate, onToggle, onRemove }) => {
  const { t } = useTranslation();
  const [showPrint, setShowPrint] = useState(false);

  return (
    <div className="rounded-3xl p-4 shadow-neu-sm" data-testid={`qr-zone-${zone.id}`}>
      <div className="flex items-start gap-4">
        <button type="button" data-testid={`qr-open-${zone.id}`} onClick={() => setShowPrint(true)}
          className="rounded-2xl bg-white p-2 shadow-neu-in active:shadow-neu-sm">
          <QRCodeSVG value={zone.qr_payload} size={96} level="M" />
        </button>
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-black" data-testid={`qr-zone-name-${zone.id}`}>
            {zone.name}
          </p>
          {zone.floor ? <p className="text-xs text-muted-foreground">{t("qr.floor")}: {zone.floor}</p> : null}
          <p className="mt-1 font-mono text-[11px] text-muted-foreground" dir="ltr">
            {zone.code}
          </p>
          <span
            className={`mt-2 inline-block rounded-full px-3 py-1 text-[10px] font-bold ${
              zone.active ? "bg-emerald-500/10 text-emerald-500" : "bg-destructive/10 text-destructive"
            }`}
          >
            {zone.active ? t("qr.active") : t("qr.inactive")}
          </span>
        </div>
      </div>

      <div className="mt-3 flex flex-wrap gap-2">
        <NeuButton type="button" data-testid={`qr-print-${zone.id}`} onClick={() => setShowPrint(true)}>
          <Printer className="mr-1 h-3.5 w-3.5" /> {t("qr.print")}
        </NeuButton>
        <NeuButton type="button" data-testid={`qr-rotate-${zone.id}`} onClick={() => onRotate(zone.id)}>
          <RefreshCw className="mr-1 h-3.5 w-3.5" /> {t("qr.rotate")}
        </NeuButton>
        <NeuButton type="button" data-testid={`qr-toggle-${zone.id}`} onClick={() => onToggle(zone)}>
          {zone.active ? t("qr.deactivate") : t("qr.activate")}
        </NeuButton>
        <NeuButton type="button" data-testid={`qr-delete-${zone.id}`} onClick={() => onRemove(zone.id)}>
          <Trash2 className="mr-1 h-3.5 w-3.5" /> {t("app.delete")}
        </NeuButton>
      </div>

      {showPrint ? <QrPrintModal zone={zone} branchName={branchName} onClose={() => setShowPrint(false)} /> : null}
    </div>
  );
};
